import React from 'react'
import './css/About.css'
import AboutHero from '../components/AboutHero'
import AboutStory from '../components/AboutStory'
import Footer from './../components/Footer'
import AboutTeam from '../components/AboutTeam'
import AboutClients from '../components/AboutClients'
import { Helmet } from 'react-helmet-async'

function About() {
  return (
    <div className='About'>

      <Helmet>
        <title>No:  1 south India best catering service| best catering services in south India | Catering services in Kerala | catering service near me</title>
        <meta name='keywords' content='Catering services in Kerala, catering services near me'/>
        <meta name='description' content='Welcome to Plaza Catering - your top destination for the best catering services in Kerala. Our team treats you like family, creating joyous and fun-filled atmospheres for weddings, corporate events, and more. Indulge in delightful culinary experiences that will keep you coming back for more' />

        <link rel='canonical' href='/about' />
      </Helmet>

      <AboutHero />
      <AboutStory />
      <AboutTeam />
      <AboutClients />
      <Footer />
    </div>
  )
}

export default About